var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('picture',[_c('source',{attrs:{"srcset":_vm.webpString,"type":"image/webp"}}),_c('img',{attrs:{"src":_vm.srcString,"srcset":_vm.pngString,"alt":_vm.member.name}})]),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.member.title))]),_c('a',{attrs:{"href":`mailto:${_vm.member.email}`}},[_vm._v(_vm._s(_vm.member.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }